import React, { Children, cloneElement, useState } from "react"
import {
  Button,
  Grid,
  Header,
  Icon,
  List,
  Modal,
  Popup,
  Segment,
  Table,
} from "semantic-ui-react"
import { v1 as uuidv1 } from "uuid"
import { Link } from "gatsby"
import {
  basicBenefits,
  premiumBenefits,
  proBenefits,
  businessBenefits,
} from "../../common"

const PricingModal = ({ children }) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      {Children.map(children, child => {
        return cloneElement(
          child,
          {
            onClick: () => setModalOpen(true),
          },
          null,
        )
      })}
      <Modal
        closeIcon
        open={modalOpen}
        size={"fullscreen"}
        onClose={() => setModalOpen(false)}
      >
        <Modal.Header content={"Pricing & Plans"} />
        <Modal.Content>
          <Grid stackable style={{ textAlign: "center" }}>
            <Grid.Row columns={4} centered>
              <Grid.Column>
                <Segment attached={"top"} style={{ backgroundColor: "black" }}>
                  <Header inverted content={"Basic"} textAlign={"center"} />
                </Segment>
                <Segment attached>
                  <Header
                    textAlign={"center"}
                    style={{ padding: "1em" }}
                    content={"Document 5 artworks and 1 location.\n\n"}
                  />
                  <Table striped textAlign={"center"}>
                    <Table.Body>
                      {basicBenefits.map(b => (
                        <Popup
                          key={uuidv1()}
                          header={b.header}
                          content={b.content}
                          trigger={
                            <Table.Row disabled={!b.enabled}>
                              <Table.Cell
                                textAlign={"left"}
                                content={b.header}
                              />
                              <Table.Cell textAlign={"left"} width={1}>
                                <Icon name={b.icon} />
                              </Table.Cell>
                            </Table.Row>
                          }
                        />
                      ))}
                    </Table.Body>
                  </Table>
                </Segment>
                <Segment attached={"bottom"}>
                  <Button
                    fluid
                    content={"Free"}
                    color={"black"}
                    as={Link}
                    to={"https://app.artcollection.io/register"}
                  />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment attached={"top"} style={{ backgroundColor: "black" }}>
                  <Header inverted content={"Premium"} textAlign={"center"} />
                </Segment>
                <Segment attached>
                  <Header
                    textAlign={"center"}
                    style={{ padding: "1em" }}
                    content={
                      "Document 50 artworks, unlimited locations, and 1 private room."
                    }
                  />
                  <Table striped textAlign={"center"}>
                    <Table.Body>
                      {premiumBenefits.map(b => (
                        <Popup
                          key={uuidv1()}
                          header={b.header}
                          content={b.content}
                          trigger={
                            <Table.Row disabled={!b.enabled}>
                              <Table.Cell
                                textAlign={"left"}
                                content={b.header}
                              />
                              <Table.Cell textAlign={"left"} width={1}>
                                <Icon name={b.icon} />
                              </Table.Cell>
                            </Table.Row>
                          }
                        />
                      ))}
                    </Table.Body>
                  </Table>
                </Segment>
                <Segment attached={"bottom"}>
                  <Button
                    fluid
                    content={"$10 a month"}
                    color={"black"}
                    as={Link}
                    to={"https://app.artcollection.io/register"}
                  />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment attached={"top"} style={{ backgroundColor: "black" }}>
                  <Header inverted content={"Pro"} textAlign={"center"} />
                </Segment>
                <Segment attached>
                  <Header
                    textAlign={"center"}
                    style={{ padding: "1em" }}
                    content={
                      "Document unlimited artworks, locations, and private rooms. \n"
                    }
                  />
                  <Table striped textAlign={"center"}>
                    <Table.Body>
                      {proBenefits.map(b => (
                        <Popup
                          key={uuidv1()}
                          header={b.header}
                          content={b.content}
                          trigger={
                            <Table.Row disabled={!b.enabled}>
                              <Table.Cell
                                textAlign={"left"}
                                content={b.header}
                              />
                              <Table.Cell textAlign={"left"} width={1}>
                                <Icon name={b.icon} />
                              </Table.Cell>
                            </Table.Row>
                          }
                        />
                      ))}
                    </Table.Body>
                  </Table>
                </Segment>
                <Segment attached={"bottom"}>
                  <Button
                    fluid
                    content={"$25 a month"}
                    color={"black"}
                    as={Link}
                    to={"https://app.artcollection.io/register"}
                  />
                </Segment>
              </Grid.Column>
              <Grid.Column>
                <Segment attached={"top"} style={{ backgroundColor: "black" }}>
                  <Header inverted content={"Business"} textAlign={"center"} />
                </Segment>
                <Segment attached>
                  <Header
                    textAlign={"center"}
                    style={{ padding: "1em" }}
                    content={
                      "Document unlimited artworks, locations, and private rooms. \n"
                    }
                  />
                  <Table striped textAlign={"center"}>
                    <Table.Body>
                      {businessBenefits.map(b => (
                        <Popup
                          key={uuidv1()}
                          header={b.header}
                          content={b.content}
                          trigger={
                            <Table.Row disabled={!b.enabled}>
                              <Table.Cell
                                textAlign={"left"}
                                content={b.header}
                              />
                              <Table.Cell textAlign={"left"} width={1}>
                                <Icon name={b.icon} />
                              </Table.Cell>
                            </Table.Row>
                          }
                        />
                      ))}
                    </Table.Body>
                  </Table>
                </Segment>
                <Segment attached={"bottom"}>
                  <Button
                    fluid
                    content={"Contact Us"}
                    color={"black"}
                    as={"a"}
                    href="mailto:info@artcollection.io?subject=Business Account Inquiry"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    </>
  )
}

export default PricingModal
